import Vue from 'vue';
import '@/Plugins';
import '@/Utilities';
import '@/Layouts';
import '@/Components';
import i18n from '@/Plugins/i18n';
import { isNumeric } from 'dinero.js/src/services/helpers.js';
import { App as InertiaApp, plugin as InertiaPlugin, } from '@inertiajs/inertia-vue';
import { InertiaProgress } from '@inertiajs/progress';
import DataHydrator from '@/Services/DataHydrator';
import StoreManager from '@/Services/StoreManager';
import Auth from '@/Services/Auth/Auth';
import User from '@/Models/User';
import Session from '@/Services/Session';
import Notifier from '@/Services/Notifier';
Vue.config.productionTip = false;
Vue.config.performance = true;
Vue.filter('percent', function (value) {
    if (isNumeric(value) && !isNaN(parseFloat(value))) {
        return parseFloat(value).toFixed(2) + ' %';
    }
    return null;
});
// Global mixin
const globalMixin = {
    methods: { route },
    computed: {
        auth: () => window.auth,
    },
};
Vue.mixin(globalMixin);
// Inertia
Vue.use(InertiaPlugin);
// Initialise Inertia Progress
InertiaProgress.init();
// Create the Vue application instance...
new Vue({
    i18n,
    created: function () {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.$inertia.on('success', (event) => {
            var _a;
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const locale = ((_a = event.detail.page.props.jetstream) === null || _a === void 0 ? void 0 : _a.locale) ||
                i18n.locale;
            document.documentElement.lang = i18n.locale = locale;
        });
    },
    render: (h) => h(InertiaApp, {
        props: {
            initialPage: JSON.parse(window.app.dataset.page),
            // eslint-disable-next-line @typescript-eslint/no-var-requires
            resolveComponent: (name) => require(`./Pages/${name}`).default,
            transformProps: props => {
                window.storeManager = new StoreManager(props.config.storeManager);
                window.auth = new Auth(props.auth.user ? new User(props.auth.user) : null);
                window.session = new Session(props.session);
                if (props.hasOwnProperty('session')) {
                    Notifier.sendNotificationsIfNeeded(props.session);
                }
                return DataHydrator.fromProps(props);
            },
        },
    }),
}).$mount('#app');
